<template>
  <header class="page-header">
    <c-container>
      <div class="page-header__inner">
        <a
          :href="$t('linkHome')"
          class="page-header__logo"
        >
          <span class="sr-only">Miniatur Wunderland Hamburg</span>
          <img
            src="../img/logo-lettering.svg"
            alt=""
            class="page-header__logo-lettering"
          >
          <img
            src="../img/logo.svg"
            alt=""
            class="page-header__logo-full"
          >
        </a>

        <div class="page-header__language">
          <a
            v-for="(url, name) in languageURLs"
            :key="name"
            :href="url"
            class="page-header__link"
            :class="{ 'is-active': $i18n.locale === name }"
          >{{ name.toUpperCase() }}</a>
        </div>
      </div>
    </c-container>
  </header>
</template>

<script>
import CContainer from './container.vue'

export default {
  name: 'CPageHeader',

  components: {
    CContainer
  },

  computed: {
    languageURLs () {
      return LANGUAGE_URLS
    }
  },

  methods: {
    languageRoute (language) {
      if (language && this.$route.name) {
        return this.$route.name.slice(0, -2) + language
      }
    }
  }
}
</script>

<i18n locale="en">
{
  "linkHome": "https://www.miniatur-wunderland.com"
}
</i18n>

<i18n locale="de">
{
  "linkHome": "https://www.miniatur-wunderland.de"
}
</i18n>

<style lang="scss">
@import "../css/variables";
@import "../css/mixins";

.page-header {
  @include vertical-spacing;

  padding-left: $gutter-sm;
  padding-right: $gutter-sm;

  background-color: $color-primary-dark;
  box-shadow: 0 0 0.25em rgb(0 0 0 / 0.1);

  @media (min-width: $breakpoint-sm) {
    padding-left: 0;
    padding-right: 0;
  }

  @media print {
    display: none;
  }
}

.page-header__loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  z-index: $z-index-loader;
}

.page-header__inner {
  display: flex;
  justify-content: space-between;
  height: 4em;

  @media (min-width: $breakpoint-md) {
    height: 5em;
  }
}

.page-header__logo {
  display: block;
  align-self: top;
  position: relative;
  width: 12em;
  height: 8em;
  transform: translateY(-4em);

  background-color: #fff;
  box-shadow: 0 0 0.5em rgb(0 0 0 / 0.25);

  z-index: $z-index-logo;

  will-change: transform;

  @media (min-width: $breakpoint-md) {
    width: 15em;
    height: 10em;
    transform: translateY(-5em);

    @media (prefers-reduced-motion: no-preference) {
      transition: transform 0.2s;
    }

    &:hover {
      transform: translateY(0);
    }
  }
}

.page-header__logo-lettering,
.page-header__logo-full {
  position: absolute;
  bottom: 1em;
  width: 66%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;

  @media (prefers-reduced-motion: no-preference) {
    transition: opacity 0.2s;
  }
}

.page-header__logo-lettering {
  @media (min-width: $breakpoint-md) {
    .page-header__logo:hover & {
      opacity: 0;
    }
  }
}

.page-header__logo-full {
  opacity: 0;

  @media (min-width: $breakpoint-md) {
    .page-header__logo:hover & {
      opacity: 1;
    }
  }
}

.page-header__language {
  display: flex;
  flex-shrink: 0;
  align-self: center;
  margin-left: 0.75em;
}

.page-header__link {
  margin-left: 0.25em;
  padding: 0;

  font-family: $font-family;
  font-size: 1em;
  text-decoration: none;
  color: #fff;

  background: none;
  border: none;

  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &.is-active {
    text-decoration: underline;
  }
}

.page-header__print-title {
  display: none;
}
</style>
